










































import { FormField } from '@ssp/inscreva-sse-models';
import debounce from 'lodash.debounce';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class DynamicFormFieldComponent extends Vue {
  @Prop({ default: false })
  private isEditing!: boolean;

  @Prop({ required: true })
  field!: FormField;

  search: () => void = null;

  constructor() {
    super();
  }

  fieldChange() {
    if (!this.field.allowSearch || !this.field.value) {
      return;
    }
    this.search =
      this.search ||
      debounce(() => {
        const obj: any = {};
        obj[this.field.name] = this.field.value;
        return this.$emit('on-search', obj);
      }, 500);
    this.search();
  }
}
